import { useCurrentSite } from '@hotjar/site';
import { NewSurveyMessage as Message } from '@hotjar/webapp/features/Surveys/Responses/NewSurveyMessage';
import { useSurveyWidgetQuery } from '../../../domain/Surveys/query';
import { InactiveState } from '../InactiveState/InactiveState';

export const NewSurveyMessage = ({
  surveyId,
  onEdit,
}: {
  surveyId: number;
  onEdit: () => void;
}): JSX.Element | null => {
  const { data: site } = useCurrentSite();
  const { data: survey } = useSurveyWidgetQuery(site?.id, surveyId);
  const emailEnabled = survey ? survey.forwarding_email_address_list.length > 0 : false;

  if (!site || !survey) return null;

  return survey.enabled ? (
    <Message siteId={site.id} surveyId={surveyId} onEdit={onEdit} emailEnabled={emailEnabled} />
  ) : (
    <InactiveState survey={survey} site={site} />
  );
};
